export function isPreview() {
    return import.meta.env.VITE_NODE_ENV === 'preview';
}

export function isDevelopment() {
    return import.meta.env.MODE === 'development';
}